import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import AttachFile from './AttachFile';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Receipt from '../models/Receipt';
import { useServiceCtx,
    CERequestType,
    MileageRequest,
    MileageRequestContainer
 } from './TimeAndExpenseServiceContext';
import UserExpense from 'src/models/AP/EmployeeExpense';
import DayEntry from 'src/models/AP/DayEntry';
import FileType from '../models/FileType';
import { FaDollarSign } from 'react-icons/fa';
import { FiDelete } from 'react-icons/fi';
import { FaRoad } from 'react-icons/fa';
import CalendarDay from 'src/models/AP/CalendarDay';
import { AnyObject } from 'final-form';

interface IExpenseProps {
  register: ReturnType<typeof useForm>['register'];
  setValue: ReturnType<typeof useForm>['setValue'];
  inputName: string;
  otherInputName?: string;
  expenseLabel: string;
  expenseCode: string;
  index: number;
  dayEntryIndex: number;
  calendarDayIndex?: number;
  dayEntry: DayEntry;
  expenseCount?: number;
  tooltipContent?: string;
  disableExpense?: boolean;
  displayReceitps?: (
    flag: boolean,
    esId?: number,
    expenseCount?: number,
    tsdiNumber?: number
  ) => void;
  adminToUser?: boolean;
  payperiod?: string;
}

const Expense = ({
  register,
  setValue,
  inputName,
  otherInputName,
  expenseLabel,
  expenseCode,
  calendarDayIndex,
  dayEntryIndex,
  dayEntry,
  expenseCount,
  tooltipContent,
  disableExpense,
  displayReceitps,
  adminToUser,
  payperiod,
}: IExpenseProps) => {
  const {
    createExpense,
    editExpense,
    uploadReceipt,
    getMileage,
    getTEData,
    deleteExpense,
    adminGetUserInfo
  } = useServiceCtx();
  // State variables
  const [esId, setEsId] = useState(0);
  const [otherDescript, setOtherDescript] = useState('');
  const [showDollarSign, setShowDollarSign] = useState(true);
  const [userExpenses, setUserExpenses] = useState<Array<UserExpense>>([]);
  const [errorFlag, setErrorFlag] = useState(false);
  const [showDeleteBtn, setShownDeleteBtn] = useState(false);
  const [successfulReceipts, setSuccesfulReceipts] = useState(0);
  const [hasReceipts, setHasReceipts] = useState(false);
  const [initialExpense, setInitalExpense] = useState(false);
  const [expObj, setExpObj] = useState<AnyObject>({});
  const [filesToUpload, setFilesToUpload] = useState<Array<FileType>>([]);
  const [label, setLabel] = useState<string>();

  useEffect(() => {
    if (!!dayEntry?.userExpenses) {
      setUserExpenses(dayEntry.userExpenses);
      dayEntry.userExpenses.forEach((ue: UserExpense) => {
        if (ue.amount !== '' && ue.code === expenseCode) {
          setShownDeleteBtn(true);
          setInitalExpense(true);
          setValue(`expenses.${calendarDayIndex}.${dayEntryIndex}.${ue.description.toLocaleLowerCase()}`, ue.amount);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!!esId) {
      console.log(esId);
    }
  }, [esId, showDollarSign]);

  useEffect(() => {
    if (!!expenseCount && expenseCount > 0) {
      setSuccesfulReceipts(expenseCount);
    } else if (expenseCount === 0) {
      setHasReceipts(false);
      setSuccesfulReceipts(0);
    }
  }, [expenseCount]);

  useEffect(() => {
    if (!!expObj && filesToUpload?.length > 0) {
      handleCreateExpense(expObj?.value, expObj?.label);
    }
  }, [filesToUpload, expObj]);

  useEffect(() => {
    if (!!initialExpense && filesToUpload?.length > 0) {
      handleUploadFiles(filesToUpload, label);
    }
  }, [initialExpense, filesToUpload]);

  const newPostReceipt = (uploadedFile: FileType, expId: number) => {
    let newReceipt: Receipt = receiptFactory(uploadedFile!.fileInfo);

    if (!!uploadedFile) {
      let file = new FormData();
/*       const fileBlob = new Blob([uploadedFile?.fileContent!]);
      let fileData = new File(
        [fileBlob],
        uploadedFile.fileInfo?.name,
        uploadedFile.fileInfo
      ); */

      file.append('file', uploadedFile?.fileInfo);
      file.append('fileName', uploadedFile?.fileInfo?.name);
      uploadReceipt!(file, expId)
        .then((val: number) => {
          let expenseToEdit = userExpenses!.find((ue) => ue.esId === expId);
          let expenseToEditIndex = userExpenses!.findIndex(
            (ue) => ue.esId === expId
          );

          let receipts = !!expenseToEdit?.receipts
            ? [...expenseToEdit?.receipts]
            : [];
          if (!!expenseToEdit) {
            newReceipt.expenseRecordId = val;
            receipts.push(newReceipt);
            expenseToEdit.receipts = [...receipts];
            setSuccesfulReceipts(receipts?.length);

            editExpense!(expenseToEdit)
              .then((val2: number) => {
                if (val2 === 201) {
                  console.log('successfully edit the desired expense');
                  console.log(
                    `${expenseToEdit?.description} edited successfully`
                  );
                  displayReceitps!(
                    true,
                    expenseToEdit?.esId!,
                    receipts?.length!,
                    dayEntry?.tsdNo
                  );
                  setErrorFlag(false);
                  setHasReceipts(true);

                  dayEntry.userExpenses![expenseToEditIndex].receipts! =
                    receipts;
                  setUserExpenses(dayEntry?.userExpenses!);
                }
              })
              .catch((e: unknown) => {
                console.log(
                  'error trying to edit new receipts to existing expense, ',
                  e
                );
                console.log('Error updating receipts on existing expense');
                // setErrorFlag(true);
              });
          }
        })
        .catch((e: unknown) => {
          console.log('error ocurred while trying to upload receipt', e);
          console.log('Error trying to upload receipt');
        });
    }
  };

  const receiptFactory = (file: File): Receipt => {
    let receipt = new Receipt();

    receipt.expenseRecordId = 0;
    receipt.fileDate = new Date(file?.lastModified).toLocaleDateString();
    receipt.fileName = file?.name;
    receipt.fileSize = file?.size;

    return receipt;
  };

  const handleUploadFiles = (files: Array<FileType>, expLabel?: string) => {
    if (!initialExpense) {
      if (!!expObj) {
        setFilesToUpload(files);
        setLabel(expLabel!);
      }
    } else {
      if (files.length > 0) {
        let expenseId = userExpenses.find(
          (ue) => ue.description === expLabel
        )?.esId;

        if (!!expenseId) {
          for (let i = 0; i < files.length; i++) {
            if (!!errorFlag) {
              break;
            }

            newPostReceipt(files[i], expenseId!);
          }
          setFilesToUpload([]);
        }
      }
    }
  };

  const checkUpdate = (desc: string, val: string): boolean => {
    let currentExpenses = userExpenses;
    if (currentExpenses!.length > 0) {
      let expense = currentExpenses?.find((ce) => ce.description === desc);
      if (!!expense && desc !== 'Mileage') {
        if (`${expense.amount}` === val) {
          return false;
        } else {
          return true;
        }
      } else if (!!expense && desc === 'Mileage') {
        if (expense?.mileage === parseInt(val, 10)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const expenseExists = (desc: string): UserExpense | undefined => {
    let currentExpenses = userExpenses;
    if (currentExpenses!.length > 0) {
      let expense = currentExpenses?.find((ce) => ce.description === desc);
      if (!!expense) {
        return expense;
      }
    } else {
      return undefined;
    }
    return undefined;
  };

  const requestGenerator = (expenseObj: AnyObject, mileageContainer: MileageRequestContainer) => {
    if (expenseObj?.esId! > 0) {
      let newObj = expenseObj;
      newObj.droveTo = '';
      newObj.droveFrom = '';

      if (!!newObj) {
        editExpense!(newObj)
          .then((val: number) => {
            if (val === 201) {
              console.log('successfully updated the expense');
              console.log(`${newObj.description} Updated!!`);
              dayEntry.userExpenses = dayEntry?.userExpenses?.filter(
                (ue: UserExpense) => ue?.esId !== newObj?.esId!
              );
              dayEntry?.userExpenses?.push(newObj);
              setEsId(newObj?.esId!);
              setUserExpenses(dayEntry?.userExpenses!);
            }
          })
          .catch((e: unknown) => {
            console.log('something went wrong, ', e);
          });
      }
    } else {
      let postObj: CERequestType = {
        mileageRequestContainer: mileageContainer,
        userExpense: expenseObj,
      };

      if (!!postObj) {
        createExpense!(postObj)
          .then((val: { esId: number}) => {
            if (!!val) {
              setEsId(val?.esId);
              postObj.userExpense.esId = val?.esId;
              dayEntry.userExpenses = [
                ...dayEntry?.userExpenses!,
                postObj?.userExpense,
              ];

              setUserExpenses(dayEntry?.userExpenses!);
              setShownDeleteBtn(true);
              setInitalExpense(true);

              console.log(
                `Successfully created ${postObj?.userExpense?.description} expense!`
              );
            }
          })
          .catch((e: unknown) => {
            console.log('something went wrong, ', e);
            console.log('Error trying to create expense!');
          });
      }
    }
  };

  const handleCreateExpense = (val: string, expense: string) => {
    if (val === null || val === undefined || expense === null || expense === undefined || val === '' || expense === '' || dayEntry?.tmId === undefined) {
        if (dayEntry?.tmId === undefined) {
        window.alert('Please enter a description 1st.');
        }
        console.log('Invalid Entry!');
        return;
    }

    let currentExpense: UserExpense | undefined = expenseExists(expense);
    let needsUpdate = checkUpdate(expense, val);
    let negativateCheck = val.split('-').includes('');
    let decimalCheck = val.split('.');

    if (val.length > 0 && !negativateCheck) {
      if (!!needsUpdate) {
        let mileageContainer: MileageRequestContainer = {
          miles: '',
        };

        let expenseObj = new UserExpense();

        expenseObj.tmId = dayEntry?.tmId;
        expenseObj.amount = val;
        expenseObj.code = expenseCode;
        expenseObj.receipts = !!currentExpense ? currentExpense?.receipts : [];
        expenseObj.description = expense;
        expenseObj.mileage = 0;
        expenseObj.esId = !!currentExpense ? currentExpense?.esId : 0;
        expenseObj.otherDescription = '';

        if (expense !== 'Mileage' && expense !== 'Other') {
          requestGenerator(expenseObj, mileageContainer);
        } else if (expense === 'Other') {
          if (!!otherDescript && otherDescript.length > 0) {
            expenseObj.otherDescription = otherDescript;
            requestGenerator(expenseObj, mileageContainer);
          } else {
            console.log('Other Expense Requires a description!');
          }
        } else {
          if (decimalCheck.length > 1) {
            console.log('Decimal values are not allowed in a Mileage Expense');
          } else {
            let mileageObj: MileageRequest = {
              clientNumber: dayEntry?.clientNumber!,
              prospectNumber: dayEntry?.prospectNumber!,
              payPeriodNumber: `${dayEntry?.periodNo!}` === 'undefined' ? payperiod!.replace('-', '') : `${dayEntry?.periodNo!}`,
              miles: val,
            };

            getMileage!(mileageObj)
              .then((res: number) => {
                expenseObj.amount = `${res}`;
                expenseObj.mileage = parseInt(val, 10);

                mileageContainer.miles = val;

                setShowDollarSign(false);
                setValue(inputName, `${res}`);

                requestGenerator(expenseObj, mileageContainer);
              })
              .catch((e: unknown) => {
                console.log(
                  'error while trying to get mileage expense val, ',
                  e
                );
              });
          }
        }
      } else {
        console.log('Amount is the same as previous, no update needed.');
      }
    } else if (val.length > 0 && !!negativateCheck) {
      console.log('Negative Amounts are not allowed!');
    } else {
        console.log('Amount cannot be empty!');
    }
  };

  const handleDeleteExpense = (code: string) => {
    let expId: number | undefined = userExpenses.find(
      (ue) => ue.code === code
    )?.esId;
    if (!!esId) {
      deleteExpense!(expId)
        .then((val: number) => {
          if (val === 201) {
            if (!adminToUser) {
              getTEData!(false)
                .then((teData: { calendarDays: Array<CalendarDay>}) => {
                  let userExp: UserExpense[] | undefined =
                    teData?.calendarDays[calendarDayIndex!]?.dayEntries?.find(
                      (de: DayEntry) => de?.tmId === dayEntry?.tmId
                    )?.userExpenses;

                  dayEntry.userExpenses = userExp;
                  setUserExpenses(userExp!);
                })
                .catch((e: unknown) => {
                  console.log('error val, ', e);
                });
              if (code !== 'O' && code !== 'G') {
                setValue(inputName!, '');
                setInitalExpense(false);
              } else if (code === 'G') {
                setValue(`${otherInputName}.miles`, '');
                setValue(inputName!, '');
              } else {
                setValue(inputName!, '');
                setValue(`${otherInputName}.otherDescription`, '');
                setInitalExpense(false);
              }
              setShownDeleteBtn(false);
              setSuccesfulReceipts(0);
              setHasReceipts(false);
              displayReceitps!(true, expId);
            } else {
              let id = `${dayEntry?.tsdNo}`;
              adminGetUserInfo!(payperiod!, id)
                .then((teData: { calendarDays: Array<CalendarDay>}) => {
                  let userExp: UserExpense[] | undefined =
                    teData?.calendarDays[calendarDayIndex!]?.dayEntries?.find(
                      (de: DayEntry) => de?.tmId === dayEntry?.tmId
                    )?.userExpenses;

                  dayEntry.userExpenses = userExp;
                  setUserExpenses(userExp!);
                })
                .catch((e: unknown) => {
                  console.log('error val, ', e);
                });
              if (code !== 'O' && code !== 'G') {
                setValue(inputName!, '');
              } else if (code === 'G') {
                setValue(`${otherInputName}.miles`, '');
                setValue(inputName!, '');
              } else {
                setValue(inputName!, '');
                setValue(`${otherInputName}.otherDescription`, '');
              }
              setShownDeleteBtn(false);
              setSuccesfulReceipts(0);
              setHasReceipts(false);
              displayReceitps!(true, expId, undefined, dayEntry?.tsdNo);
            }
          }
        })
        .catch((e: unknown) => {
          console.log('error val, ', e);
        });
    }
  };

  const hoverDisplayFunc = (code?: string) => {
    let exp: UserExpense | undefined = dayEntry?.userExpenses?.find(
      (ue: UserExpense) => ue?.code === code
    );

    let expId = exp?.esId;
    let receipts = exp?.receipts?.length;

    if (!!expId && receipts! > 0) {
      displayReceitps!(true, expId, dayEntry?.tsdNo);
      setSuccesfulReceipts(receipts!);
      setHasReceipts(true);
    } else {
      displayReceitps!(false);
      setHasReceipts(false);
    }
  };

  return (
    <div className="flex justify-center items-center mb-2">
      <h5
        data-tooltip-id="expense-tooltip"
        data-tooltip-content={tooltipContent}
        data-tooltip-place="left"
        data-tooltip-position-strategy="absolute"
        data-tooltip-delay-show={500}
        data-expense-label={expenseLabel}
        className={`w-[175px] text-center border-t-[1px] rounded border-b-[1px] border-l-[1px] p-[4px] hover:cursor-pointer ${
          !!hasReceipts ? 'border-green-500' : 'border-gray-300'
        }`}
      >
        {expenseLabel === 'Motel' ? 'Hotel' : expenseLabel}
      </h5>
      {!!expenseCode && expenseCode === 'O' && (
        <RHFInputBox
          register={register}
          placeholder={'description'}
          className={`w-[150px] text-center border-gray-300 border-t-[1px] rounded border-b-[1px] border-l-[1px] p-[4px] ${
            disableExpense ? 'cursor-not-allowed bg-gray-300' : ''
          }`}
          name={`${otherInputName}.otherDescription`}
          rules={{
            onBlur(event: React.FocusEvent<HTMLInputElement>) {
              setOtherDescript(event.target.value);
            },
          }}
          onClick={() => hoverDisplayFunc(expenseCode)}
          disabled={disableExpense}
        />
      )}
      {!!expenseCode && expenseCode === 'G' && (
        <div
          className={`w-[150px] flex gap-2 items-center border border-gray-300 px-2 py-1 border-t-[1px] rounded border-l-[1px] p-[4bg-cyan-50          
          ${
            !!hasReceipts
              ? 'border-green-500 '
              : disableExpense
              ? 'cursor-not-allowed bg-gray-300'
              : 'border-gray-300'
          }
          `}
        >
          <span className={'text-gray-400 text-[19px]'}>
            {<FaRoad />}
          </span>
          <RHFInputBox
            register={register}
            name={`${otherInputName}.miles`}
            placeholder={'miles'}
            className={'w-[75px] p-[0px_0px_0px_8px]'}
            rules={{
              onBlur(event: React.FocusEvent<HTMLInputElement>) {
                handleCreateExpense(event.target.value, expenseLabel);
              },
            }}
            onClick={() => hoverDisplayFunc(expenseCode)}
            disabled={disableExpense}
          />
        </div>
      )}
      <div
        className={`w-[150px] flex gap-2 items-center border border-gray-300 px-2 py-1 border-t-[1px] rounded border-l-[1px] p-[4px] ${
          expenseCode === 'G' ||
          expenseCode === 'Os' ||
          expenseCode === 'Tr' ||
          disableExpense
            ? 'cursor-not-allowed bg-gray-300'
            : !!hasReceipts
            ? 'border-green-500 border-2'
            : 'border-gray-300'
        }`}
      >
        <span className={'text-gray-400 text-[19px]'}>
          <FaDollarSign />
        </span>

        <RHFInputBox
          register={register}
          placeholder={'amount'}
          className={'w-[110px] text-center'}
          name={inputName}
          rules={{
            onBlur(event: React.FocusEvent<HTMLInputElement>) {
              if (expenseCode !== 'M' && expenseCode !== 'V' && expenseCode !== 'Y' && !initialExpense) {
                setExpObj({
                  value: event.target.value,
                  label: expenseLabel,
                });
              } else {
                handleCreateExpense(event.target.value, expenseLabel);
              }
            },
          }}
          disabled={expenseCode === 'G' ? true : disableExpense}
          onClick={() => hoverDisplayFunc(expenseCode)}
        />
      </div>
      <AttachFile
        onFilesUpload={handleUploadFiles}
        DnDMessage={'Upload'}
        customClasses={`p-[3px] w-[150px] ${
          !!hasReceipts ? 'border-green-500' : 'border-gray-300'
        }`}
        expenseLabel={expenseLabel}
        successfulReceipts={successfulReceipts}
        hasRestrictions={true}
        disabled={disableExpense}
      />
      {!!showDeleteBtn && !disableExpense && (
        <span
          className="bg-red-500 text-white w-[50px] ml-2 text-[28px] px-[10px] py-[4px] rounded text-center hover:bg-red-800 active:bg-red-300 cursor-pointer"
          onClick={() => handleDeleteExpense(expenseCode)}
        >
          {<FiDelete />}
        </span>
      )}
      {!showDeleteBtn && <div className="w-[60px]" />}
    </div>
  );
};

export default Expense;


// WEBPACK FOOTER //
// ./src/components/project-billing/components/Expense.tsx